export default {
  vacations: [
    ['2024-12-21', '2025-01-08'], // Weihnachtsferien
    ['2025-02-03', '2025-02-09'], // Semesterferien
    ['2025-04-11', '2025-04-21'], // Osterferien
    ['2025-10-27', '2025-10-31'], // Herbstferien
  ],
  holidays: [
    '2024-11-01', // Allerheiligen
    '2024-11-02', // Allerseelen
    '2024-11-15', // St. Leopold
    '2024-12-08', // Mariä Empfängnis
    '2024-12-25', // Christtag
    '2024-12-26', // Stefanitag
    '2025-01-01', // Neujahr
    '2025-01-06', // Heilige drei Könige
    '2025-04-20', // Ostern
    '2025-04-21', // Ostermontag
    '2025-05-01', // Staatsfeiertag Österreich
    '2025-05-29', // Christi Himmelfahrt
    '2025-06-08', // Pfingsten
    '2025-06-09', // Pfingstmontag
    '2025-06-19', // Fronleichnam
    '2025-08-15', // Mariä Himmelfahrt
    '2025-10-26', // Nationalfeiertag Österreich
    '2025-11-01', // Allerheiligen
    '2025-11-02', // Allerseelen
    '2025-11-15', // St. Leopold
    '2025-12-08', // Mariä Empfängnis
    '2025-12-25', // Christtag
    '2025-12-26', // Stefanitag
  ],
};



//////////////////
// WEBPACK FOOTER
// ./static/js/vacation.js
// module id = 5NQQ
// module chunks = 0